import { Component, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';

import { AuthService } from '../../../auth/auth.service';
import { MenuService } from '../menu.service';
import { DestinatarioMenu } from '../../../../asistente-en-linea/models/DestinatarioMenu';
import { Destinatario } from '../../../../asistente-en-linea/models/Destinatario';
import { DestinatariosService } from '../../destinatarios/destinatarios.service';
import { AsistenteMenuService } from '../../asistente-menu/asistente-menu.service';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-destinatarios-menu',
  templateUrl: './destinatarios-menu.component.html',
  styleUrls: ['./destinatarios-menu.component.scss']
})
export class DestinatariosMenuComponent implements OnInit {
  cargandoDatos: boolean;
  destinatariosMenu: Destinatario[];
  destinatariosMenuSeleccionados: DestinatarioMenu[];
  destinatarioSeleccionado: DestinatarioMenu;
  idMenu: string;
  descripcion: string;
  loading: boolean;
  displayedColumns = ['select', 'titulo', 'descripcion', 'habilitado', 'target', 'targetType'];
  dataSource: any;
  selection: any;
  initialSelection: any;
  allowMultiSelect: boolean;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  
  constructor(private destinatariosService: DestinatariosService, private menuService: MenuService, private route: ActivatedRoute, private router: Router, private authService: AuthService,
    private asistenteMenuService: AsistenteMenuService
  ) {
    this.loading = false;
    this.initialSelection = [];
    this.allowMultiSelect = true;
    this.selection = new SelectionModel<Destinatario>(this.allowMultiSelect, this.initialSelection);
    this.idMenu = "1";
  }



  ngOnInit() {
    this.route.queryParamMap.subscribe((params: any) => {
      this.idMenu = params.params.idMenu;
      this.loadDestinatariosMenu();
      this.loadMenu();
    })
  }

  loadMenu() {
    this.cargandoDatos = true;
    this.asistenteMenuService.loadMenuByID(this.idMenu).subscribe((data: any) => {
      if (data && (data.statusCode == 200 || data.statusCode == 0)) {
        let menuBD = data.content;
        this.descripcion = menuBD.descripcion;
        this.cargandoDatos = false;
      }
      else {
        alert(data.statusMessage);
        this.cargandoDatos = false;
      }
    },
      error => {
        alert(error);
        this.cargandoDatos = false;
      })
  }


  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  async loadDestinatariosMenu() {
    this.loading = true;
    this.destinatariosMenu = [];

    let resArray = [];
    this.loading = true;
    resArray.push(await this.destinatariosService.loadDestinatariosMenu(false).toPromise().catch((err) => {
      this.loading = false;
      alert(err);
    }));

    let noErr = resArray.reduce((previous, current) => {
      if (previous && (current.statusCode == 200 || current.statusCode == 0)) {
        const resultado = current.content;
        if (resultado.length > 0) {
          for (let m of resultado) {
            let destMenu = new Destinatario(
              m.id,
              m.codigo,
              m.descripcion,
              m.titulo,
              m.targetType,
              m.target,
              null,
              null,
              m.usuarioAutualizador,
              m.habilitado
            );
            this.destinatariosMenu.push(destMenu);
          }
        }
        return true;
      }
      return false;
    }, true);

    if (noErr) {
      this.dataSource = new MatTableDataSource(this.destinatariosMenu);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      let resArray = [];
      resArray.push(await this.menuService.loadDestinatariosMenu(this.idMenu, false).toPromise().catch((err) => {
        alert(err);
      }));

      let noErr = resArray.reduce((previous, current) => {
        if (previous && (current.statusCode == 200 || current.statusCode == 0)) {
          const resultado = current.content;
          if (resultado.length > 0) {
            for (let m of resultado) {
              this.dataSource.data.forEach(row => {
                if (row.id == m.destinatario.id) {
                  this.selection.toggle(row);
                  this.selection.isSelected(row)
                  this.selection.select(row);
                  return;
                }
              });
            }
          }
          return true;
        }
        return false;
      }, true);

      if (noErr) {
        //this.dataSource.data.forEach(row => this.selection.select(row));
      } else {
        alert("Ocurrió un error, intente nuevamente más tade");
      }
    } else {
      alert("Ocurrió un error, intente nuevamente más tade");
    }

    this.loading = false;
  }

  irPaginaInicio() {
    this.router.navigate(['/config/home/']);
  }

  cancelOperation() {
    this.irPaginaInicio();
  }
  async applyOperation() {
    this.loading = true;
    this.destinatariosMenuSeleccionados = [];
    //console.log("this.selection.selection: " + this.selection._selection);
    this.selection._selection.forEach((item) => {
      this.destinatariosMenuSeleccionados.push(item.id)
    });


    let resArray = [];
    resArray.push(await this.menuService.guardarDestinatariosMenu(this.idMenu, this.authService.getUser().username, this.destinatariosMenuSeleccionados).toPromise().catch((err) => {
      //alert(err);
    }));

    let noErr = resArray.reduce((previous, current) => {
      return previous && (current.statusCode == 200 || current.statusCode == 0 ? true : false);
    }, true)

    if (noErr) {
      this.irPaginaInicio();
    } else {
      alert("Ocurrió un error, intente nuevamente más tade");
    }
    this.loading = false;
  }
}